import { render, staticRenderFns } from "./TransportsEmissionFactors.vue?vue&type=template&id=1e6a8509&scoped=true"
import script from "./TransportsEmissionFactors.vue?vue&type=script&lang=js"
export * from "./TransportsEmissionFactors.vue?vue&type=script&lang=js"
import style0 from "./TransportsEmissionFactors.vue?vue&type=style&index=0&id=1e6a8509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6a8509",
  null
  
)

export default component.exports